(() => {
  const desktop = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const bound = new WeakSet();
  const setOpen = (details, open) => {
    details.open = open;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(open));
  };
  const bind = () => document.querySelectorAll('.header__inline-menu header-menu > details').forEach(details => {
    if (bound.has(details)) return;
    bound.add(details);
    let timer;
    details.addEventListener('pointerenter', event => {
      if (!desktop.matches || event.pointerType !== 'mouse') return;
      clearTimeout(timer);
      document.querySelectorAll('.header__inline-menu header-menu > details').forEach(other => {
        if (other !== details) setOpen(other, false);
      });
      setOpen(details, true);
    });
    details.addEventListener('pointerleave', event => {
      if (!desktop.matches || event.pointerType !== 'mouse') return;
      timer = setTimeout(() => {
        if (!details.matches(':hover') && !details.contains(document.activeElement)) setOpen(details, false);
      }, 180);
    });
    details.addEventListener('keydown', event => {
      if (event.key === 'Escape' && details.open) {
        event.preventDefault(); event.stopPropagation(); clearTimeout(timer);
        setOpen(details, false); details.querySelector(':scope > summary')?.focus();
      }
    });
  });
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
